export default __webpack_public_path__ + "static/media/7 Muscle Activation & Corrective Exercise Videos.5cfc94f1.png";